import { html } from '@/helpers/html-template'
import type { AttributesButton } from './attributes'
import { guideIconHtml } from '@scalar-org/guide-icons'
import { EditorClasses } from '@/styles'
import { toVueComponent } from '@scalar-org/vue-render'
export function guideButtonHtml(props: AttributesButton) {
  return html`
    <a
      class="${EditorClasses.Button}"
      href="${props.href}"
      rel="noopener noreferrer"
      target="_blank">
      ${props.icon && guideIconHtml({ src: props.icon, title: 'link icon' })}
      ${props.title}
      <ssg-children />
    </a>
  `
}

/** Scalar Button wrapped in Vue for usage in the Tiptap extensions */
export const ScalarButtonVue = toVueComponent<AttributesButton>(
  guideButtonHtml,
  {
    href: String,
    title: String,
    icon: String,
  },
)
